(ns common.display-tag
  (:require [uix.core :as uix :refer [$ defhook defui]]))

(defhook use-text-blob [content type]
  (let [[blob-url-state set-blob-state] (uix/use-state nil)]
    (uix/use-effect (fn []
                      (let [blob (js/Blob. #js [content]
                                           #js {:type type})
                            blob-url (js/URL.createObjectURL blob)]
                        (set-blob-state blob-url)
                        (fn []
                          (set-blob-state nil)
                          (js/URL.revokeObjectURL blob-url))))
                    [content type])
    blob-url-state))

(defui display-tag [{:keys [tag-text width height iframe-ref scale]
                     :or {scale 1}}]
  ;; This is a hack to make sure that the script DOM elements in the tag-text will be executed by the browser,
  ;; because simply setting the `innerHTML` property won't run the scripts.
  ;;
  ;; Note: Please ensure that the page which is using this component has an CSP which allows
  ;;       using blobs as src parameter to the iframe, otherwise it won't work.
  (let [blob-url (use-text-blob (str "<!DOCTYPE html>"
                                     "<html lang=\"en\">"
                                     "<head><meta charset=\"UTF-8\" /></head>"
                                     "<body style=\""
                                     "margin: 0; padding: 0; "
                                     "overflow: hidden; "
                                     "\">" tag-text "</body>"
                                     "</html>")
                                "text/html")]
    ($ :iframe
       {:src blob-url
        :ref iframe-ref
        :width width
        :height height
        :style {:border "none"
                :zoom scale}})))
